// extracted by mini-css-extract-plugin
export default {"ComponentDragSource__Draggable":"ComponentDragSource_ComponentDragSource__Draggable__ml16l"};